module.exports = __webpack_public_path__ + "static/img/resources-header.ff21b27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/resources-header.jpg
// module id = ipJD
// module chunks = 0